import { render } from "./KeyF3.vue?vue&type=template&id=7bf7d2c4"
import script from "./KeyF3.vue?vue&type=script&lang=ts"
export * from "./KeyF3.vue?vue&type=script&lang=ts"
script.render = render

export default script